export default __webpack_public_path__ + "static/VirginMoney logo-37f4dab944ab00d117b9d3b4ca8eea07.png";